import { DetailSectionWrapper } from '@exam-management/qcontent-management';
import { Flex, PaperSection } from '@shared/components';
import { useLocation, matchPath } from 'react-router-dom';

import { useQuestionReviewTaskQuestionDetails } from '../../providers';
import { QuestionDetailsView } from '../question-details-view';
import { QuestionInformationView } from '../question-information-view';
import { QuestionLocationView } from '../question-location-view';
import { QuestionParagraphView } from '../question-paragraph-view';
import { QuestionPropertiesView } from '../question-properties-view';
import { QuestionReviewTaskReviewResultSection } from '../question-review-task-review-result-section';
import { QuestionReviewTaskReviewerSummarySection } from '../question-review-task-reviewer-summary-section';

export default function QuestionReviewTaskQuestionDetailsSection() {
  const {
    workflowRoles: { isOwner },
  } = useQuestionReviewTaskQuestionDetails();

  const location = useLocation();

  const matchedMyTask = matchPath('/my-task/question-review/:taskId/*', location.pathname);

  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(6), p: theme.spacing(6) })}>
      <QuestionLocationView />
      <Flex sx={(theme) => ({ flex: 1, flexDirection: 'column', gap: theme.spacing(6) })}>
        <PaperSection title='Question Details'>
          <DetailSectionWrapper>
            <QuestionInformationView />
            <QuestionParagraphView />
            <QuestionDetailsView />
            <QuestionPropertiesView />
          </DetailSectionWrapper>
        </PaperSection>
        {isOwner && !matchedMyTask ? (
          <QuestionReviewTaskReviewerSummarySection />
        ) : (
          <QuestionReviewTaskReviewResultSection />
        )}
      </Flex>
    </Flex>
  );
}
